import i18n from '@/i18n/i18n'

export const ONBOARDING_WIZARD_ROUTE = 'onboarding'
export const ONBOARDING_WIZARD_YOUR_DETAILS_ROUTE = 'onboarding.your-details'
export const ONBOARDING_WIZARD_INTEGRATIONS_ROUTE = 'onboarding.integrations'
export const ONBOARDING_WIZARD_CARRIERS_ROUTE = 'onboarding.carriers'
export const ONBOARDING_WIZARD_YOUR_ADDRESS_ROUTE = 'onboarding.your-address'
export const ONBOARDING_WIZARD_PAYMENT_METHOD_ROUTE = 'onboarding.payment-method'
export const ONBOARDING_WIZARD_YOUR_BRAND_ROUTE = 'onboarding.your-brand'

export const ONBOARDING_WIZARD_CARRIERS_LIST_ROUTE = 'onboarding.carriers.list'
export const ONBOARDING_WIZARD_CARRIERS_CONTRACTS_LIST_ROUTE = 'onboarding.contract-list'
export const ONBOARDING_WIZARD_CARRIERS_CONTRACTS_SELECT_CARRIER_ROUTE = 'onboarding.contract-select_carrier'
export const ONBOARDING_WIZARD_CARRIERS_CONTRACTS_CONFIGURE_ROUTE = 'onboarding.contract-configure'
export const ONBOARDING_WIZARD_CARRIERS_CONTRACTS_REGISTER_ROUTE = 'onboarding.contract-register'
export const ONBOARDING_WIZARD_CARRIERS_CONTRACTS_REGISTER_SUBBROKER_ROUTE = 'onboarding.contract-register-subbroker'

export default {
  name: ONBOARDING_WIZARD_ROUTE,
  path: '/onboarding',
  redirect: { name: ONBOARDING_WIZARD_YOUR_DETAILS_ROUTE },
  component: () => import('@/app/onboarding-wizard/views/OnboardingWizardView.vue'),
  children: [
    {
      name: ONBOARDING_WIZARD_YOUR_DETAILS_ROUTE,
      path: '/onboarding/your-details',
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardYourDetails.vue'),
      meta: {
        pageTitle: () => i18n.t('Your details'),
        permissions: ['manage_account'],
      },
    },
    {
      name: ONBOARDING_WIZARD_INTEGRATIONS_ROUTE,
      path: '/onboarding/integrations',
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardIntegrations.vue'),
      meta: {
        pageTitle: () => i18n.t('Connect your store'),
        permissions: ['manage_integrations'],
      },
    },
    {
      name: ONBOARDING_WIZARD_CARRIERS_ROUTE,
      path: '/onboarding/carriers',
      redirect: { name: ONBOARDING_WIZARD_CARRIERS_LIST_ROUTE },
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardCarriers.vue'),
      meta: {
        pageTitle: () => i18n.t('Enable carriers'),
        permissions: ['configure_shipping'],
      },
      children: [
        {
          name: ONBOARDING_WIZARD_CARRIERS_LIST_ROUTE,
          path: '/onboarding/carriers/',
          component: () => import('@/app/settings/carriers-and-prices/views/CarrierSelection.vue'),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: [],
          },
        },
        {
          name: ONBOARDING_WIZARD_CARRIERS_CONTRACTS_LIST_ROUTE,
          path: 'contracts/list',
          component: () => import('@/app/settings/carriers-and-prices/views/ContractsList.vue'),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: ['configure_shipping'],
          },
        },
        {
          name: ONBOARDING_WIZARD_CARRIERS_CONTRACTS_SELECT_CARRIER_ROUTE,
          path: 'contracts/carrier/select',
          component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractsList.vue'),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: ['configure_shipping'],
          },
        },
        {
          name: ONBOARDING_WIZARD_CARRIERS_CONTRACTS_CONFIGURE_ROUTE,
          path: 'contracts/carrier/:carrierId/configure/:contractId?',
          component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractForm.vue'),
          props: route => ({
            carrierId: Number.parseInt(route.params.carrierId),
            contractId: route.params.contractId && Number.parseInt(route.params.contractId),
          }),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: ['configure_shipping'],
          },
        },
        {
          name: ONBOARDING_WIZARD_CARRIERS_CONTRACTS_REGISTER_SUBBROKER_ROUTE,
          path: 'contracts/carrier/:carrierCode/register-subbroker',
          component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractRegisterSubbrokerForm.vue'),
          props: route => ({
            carrierCode: route.params.carrierCode,
          }),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: ['configure_shipping'],
          },
        },
        {
          name: ONBOARDING_WIZARD_CARRIERS_CONTRACTS_REGISTER_ROUTE,
          path: 'contracts/carrier/:carrierId/register',
          component: () => import('@/app/settings/carriers-and-prices/views/CarrierContractRegisterForm.vue'),
          props: route => ({
            carrierId: Number.parseInt(route.params.carrierId),
            contractId: route.params.contractId && Number.parseInt(route.params.contractId),
          }),
          meta: {
            pageTitle: () => i18n.t('Enable carriers'),
            permissions: ['configure_shipping'],
          },
        },
      ],
    },
    {
      name: ONBOARDING_WIZARD_YOUR_ADDRESS_ROUTE,
      path: '/onboarding/your-address',
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardAddress.vue'),
      meta: {
        pageTitle: () => i18n.t('Add your address'),
        permissions: ['manage_addresses'],
      },
    },
    {
      name: ONBOARDING_WIZARD_PAYMENT_METHOD_ROUTE,
      path: '/onboarding/payment-method',
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardPayment.vue'),
      meta: {
        pageTitle: () => i18n.t('Payment details'),
        permissions: [],
      },
    },
    {
      name: ONBOARDING_WIZARD_YOUR_BRAND_ROUTE,
      path: '/onboarding/your-brand',
      component: () => import('@/app/onboarding-wizard/views/OnboardingWizardBrand.vue'),
      meta: {
        pageTitle: () => i18n.t('Your brand'),
        permissions: ['manage_brands'],
      },
    },
  ],
}
